// extracted by mini-css-extract-plugin
export default {"CheckboxRound":"CheckboxRound_CheckboxRound__dCOa7"};